define('models/calendar/day',[
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/api',
    // Collections
    'collections/calendar/day-items'
], function(
    _, Backbone, moment, U,
    // services
    API,
    CCalendarDayItems
) {

    var MCalendarDay = Backbone.Model.extend({
        idAttribute: 'date',
        defaults: function() {
            return { date: API.formatDate(moment()), };
        },

        getFilteredItems: function(fields) {
            var items = this.get('items');
            if (!fields) return items;
            if (!_.isString(fields)) fields = [fields];
            return _.filter(items, function(item) {
                return fields.indexOf(item.type) === -1;
            });
        },

        getItems: function() {
            var collection = this.items;
            if (!collection) {
                collection = this.items = new CCalendarDayItems(
                    this.getFilteredItems('point'), {
                        date: this.getDate(),
                    });
                this.listenTo(this, {
                    'change:items': this.onItemsChange
                });
            }
            return collection;
        },

        getDate: function() {
            return this.get('date');
        },

        updateItem: function(model, options) {
            var items = this.getItems();
            model.set("position", items.length - 1);
            //model.set("position", items.length);
            return items.update(model, options);
        },

        updateSession: function(session, options) {
            return this.getItems().updateSession(session, options);
        },

        resetItems: function() {
            if (!this.items) return;
            this.getItems().reset(this.getFilteredItems('point'));
            return this;
        },

        ////////////
        // events //
        ////////////
        onItemsChange: function() {
            this.resetItems();
        },
    });

    return MCalendarDay;
});

